<template>
  <LoaderComponent v-if="loadingData"></LoaderComponent>
  <div class="center testocentrato">
    <AlphabeticalComponent  v-if="this.showList" @search="onSearch" :lang="currentLang"></AlphabeticalComponent>
  </div>
  
  <p></p>
  <FoodResultComponent
    v-if="this.resultData != null && this.showList"
    :foodList="resultData"
    :language="currentLang"
    @foodSelect="onFoodSelect"
  ></FoodResultComponent>
  <div  >
  <FoodComponent
    v-if="showDetail"
    :id="currentFoodId"
    :language="currentLang"
    @error="onError"
    @back="onBack"
  ></FoodComponent>
</div>
<MessageComponent v-if="message!=''" :message="message" :messageType="messagetype"></MessageComponent>
</template>

<script>
import AlphabeticalComponent from "@/components/AlphabeticalComponent.vue";
import FoodResultComponent from "@/components/FoodResultComponent.vue";
import FoodComponent from "@/components/FoodComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import MessageComponent from "@/components/MessageComponent.vue";
import {app} from "../main.js";
import api from "../js/apiConsts.js";
import apiConsts from "../js/apiConsts.js";
import { getSTRING } from "@/js/utils";
import { axiosPost } from "../js/apiService.js";
export default {
  name: "PageFoodList",
  components: {
    AlphabeticalComponent,
    FoodResultComponent,
    LoaderComponent,
    FoodComponent,
    MessageComponent
  },
  data() {
    return {
      currentLang: this.$route.params.lang,
      currentFoodId: null,
      loadingData: false,
      resultData: null,
      showDetail: false,
      showList: true,
      TITOLO: '',
      message: '',
      messagetype: 1
    };
  },
  mounted() {
    this.TITOLO = getSTRING(this.currentLang, "TITOLO" , apiConsts.TITOLOAPP)
  },
  unmounted() {
     app.config.globalProperties.$GenericError = false;
  },
  methods: {
    onFoodSelect(food) {
      this.currentFoodId = null;
      this.currentFoodId = food.idFood;
      this.showDetail = true;
      this.showList = false;
    },
    onBack() {
      this.currentFoodId = null;
      this.showDetail = false;
      this.showList = true;
    },
    onError(message) {
      this.message = message;
    },
    async onSearch(text) {
      this.message = '';
      this.loadingData = true;
      await axiosPost(api.APIFoods, {
        language: this.currentLang.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
        searchValue: text,
      })
        .then((response) => {
          this.loadingData = false;
          let res = response.data;
          this.resultData = null;
          if (res.success) {
            this.resultData = res.foods;
          } else {
            this.message=res.message;
          }
        })
        .catch((err) => {
          this.loadingData = false;
          this.message=err.message;
        });
    },
  },
};
</script>

<style>
</style>